import { Container, Typography } from "@cleartrip/ct-design-components";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Rs } from "src/constants/common";
import SuperCoinIcon from "src/icons/superCoin.svg";
import { FareDataV1, FareDataV2, NormalizedFareData } from "./types";
import "./style.scss";
import { formatFare } from "src/utils/generalUtils";
import DownArrow from "icons/downChevron20x20.svg";
import Image from "next/image";

type DiscountsDropdownProps = {
  fareData: FareDataV1 | FareDataV2;
  totalDiscounts: number;
};

const normalizeFareData = (
  data: FareDataV1 | FareDataV2
): NormalizedFareData => {
  if (Array.isArray(data)) {
    return data;
  } else {
    return Object.keys(data.fare).map((key) => ({
      amount: data.fare[key],
      code: key,
      label: data.fareLabel[key],
    }));
  }
};

const DiscountsDropDown: FunctionComponent<DiscountsDropdownProps> = (
  props
) => {
  const { fareData, totalDiscounts } = props;

  const [openDisDropdown, setOpenDisDropdown] = useState(false);
  const discountsRef = useRef<HTMLDivElement>(null);

  const getIcon = (key: string) => {
    switch (key) {
      case "SUPERCOIN_DIS":
        return <SuperCoinIcon className="h-3" />;
      case "CT_PASS_DIS":
      case "PASS_DIS":
        return (
          <Image
            height={12}
            width={15}
            src="https://static-assets-ct.flixcart.com/ct/assets/resources/images/bus/busPass/BlueBusPassIcon.svg"
            alt="pass-icon"
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (discountsRef.current) {
      if (openDisDropdown) {
        discountsRef.current.style.height = `${discountsRef.current.scrollHeight}px`;
      } else {
        discountsRef.current.style.height = "0px";
      }
    }
  }, [openDisDropdown, fareData]);

  const normalizedFareData = normalizeFareData(fareData);
  const discountsCode = normalizedFareData.filter(
    (item) => item.code.includes("DIS") && item.amount !== 0
  );

  return (
    <Container className="mb-4">
      <Container className="flex flex-between flex-middle">
        <Container
          className="flex flex-middle"
          onClick={() => setOpenDisDropdown((prev) => !prev)}
        >
          <Typography variant="B2" className="c-pointer mr-1">
            Discounts
          </Typography>

          <DownArrow
            className={
              openDisDropdown ? "rotate-clockwise" : "rotate-antiClockwise"
            }
          />
        </Container>

        <Typography variant="B2" color={"success"}>
          -{Rs}
          {formatFare(Math.round(totalDiscounts))}
        </Typography>
      </Container>
      <div
        ref={discountsRef}
        className={`discounts-section ${openDisDropdown ? "open" : ""}`}
      >
        {discountsCode.map((item, index) => (
          <Container key={index} className="mt-2 flex flex-between flex-middle">
            <Container className="flex flex-middle">
              <Typography key={index} variant="P3" color="subheading">
                {item.label}
              </Typography>
              <div className="ml-2 h-3">{getIcon(item.code)}</div>
            </Container>
            <Typography variant="P3" color={"success"}>
              -{Rs}
              {formatFare(Math.round(Math.abs(item.amount)))}
            </Typography>
          </Container>
        ))}
      </div>
    </Container>
  );
};

export default DiscountsDropDown;
